module.exports = __webpack_public_path__ + "static/media/medal-level-badge-blocked.7b3649a6.png";